import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { MuteButton, PauseButton } from '../VideoButton';
import { ProgressiveAssetController } from './ProgressiveAssetController';
import { ProgressiveAssetWrapper } from './ProgressiveAssetWrapper';
import { Video, VideoButtons } from './styles';
export const VideoView = ({ loading = 'eager', src, type = 'video/mp4', displayPauseButton, displayMuteButton, screenReaderStrings, autoPlay, ...rest }) => {
    const [isPaused, setIsPaused] = React.useState(!autoPlay);
    const [isMuted, setIsMuted] = React.useState(!!rest.muted);
    const toggleVideoPause = () => {
        if (isPaused) {
            videoRef.current?.play();
            setIsPaused(false);
        }
        else {
            videoRef.current?.pause();
            setIsPaused(true);
        }
    };
    const toggleVideoMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
        }
        setIsMuted(!isMuted);
    };
    const { completeLoading, hasLoaded } = ProgressiveAssetController.useContainer();
    const [computedSrc, setComputedSource] = React.useState(() => {
        return loading === 'defer' ? undefined : src;
    });
    const key = loading === 'defer' ? `defer-${src}` : src;
    const videoRef = React.useRef(null);
    const isVideoReady = videoRef.current?.readyState === 4;
    React.useEffect(() => {
        if (loading === 'defer' && computedSrc !== src) {
            setComputedSource(src);
            videoRef.current?.load();
        }
    }, [computedSrc, loading, src]);
    React.useEffect(() => {
        if (isVideoReady)
            completeLoading();
    }, [completeLoading, isVideoReady]);
    return (_jsxs(_Fragment, { children: [_jsx(Video, { hasLoaded: hasLoaded, onCanPlay: completeLoading, ref: videoRef, autoPlay: autoPlay, ...rest, children: _jsx("source", { src: computedSrc, type: type }) }, key), _jsxs(VideoButtons, { children: [displayPauseButton && hasLoaded && (_jsx(PauseButton, { onClick: () => {
                            toggleVideoPause();
                        }, pauseText: screenReaderStrings?.pauseText ?? '', playText: screenReaderStrings?.playText ?? '', paused: isPaused, "aria-label": (isPaused ? screenReaderStrings?.playText : screenReaderStrings?.pauseText) ?? '' })), displayMuteButton && hasLoaded && (_jsx(MuteButton, { onClick: () => {
                            toggleVideoMute();
                        }, isMuted: isMuted, mutedText: screenReaderStrings?.muteText ?? '', notMutedText: screenReaderStrings?.unMuteText ?? '' }))] })] }));
};
export const ProgressiveAssetVideo = props => {
    return (_jsx(ProgressiveAssetWrapper, { children: _jsx(VideoView, { ...props }) }));
};
//# sourceMappingURL=ProgressiveAssetVideo.js.map